import React from 'react';
import teamPic from '../../../Assets/about.svg';
import Fade from 'react-reveal/Fade';

const About = () => {
    return (
        <section className="about overflow-hidden py-5" id="about">
            <div className="row w-100">
                <div className="row col-md-11 mx-auto align-items-center">
                    <div className="col-md-6 img">
                        <Fade duration={2000} left>
                            <img src={teamPic} alt="About NextGen Nexus" className="img-fluid" />
                        </Fade>
                    </div>

                    <div className="col-md-6 ps-2">
                        <Fade duration={2000} right>
                            <p className="miniTitle">About Us</p>

                            <h1 className="headerTitle">
                                We Build Digital Solutions That Help Your
                                <span className="headerHighlight"> Business Grow</span>
                            </h1>

                            <p className="headerContent">
                                NextGen Nexus Solutions provides custom CRM development,
                                business websites, web applications, and automation solutions
                                for startups, service providers, and growing companies.
                                Our goal is to make your business operations faster,
                                smarter, and easier to manage.
                            </p>

                            <p className="headerContent">
                                From customer management to vendor tracking, order management,
                                dashboards, payment integration, and business workflow automation,
                                we create solutions according to your exact requirements.
                            </p>

                            <a href="#contact">
                                <button className="branBtn">Discuss Your Project</button>
                            </a>
                        </Fade>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;